import script from "./custPhotoMan.vue?vue&type=script&setup=true&lang=ts"
export * from "./custPhotoMan.vue?vue&type=script&setup=true&lang=ts"

import "./custPhotoMan.vue?vue&type=style&index=0&id=48f7fc5c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f7fc5c"]])

export default __exports__